<template>
	<div class="row ml-lg-3 mr-lg-1">
		<div class="col-12 mt-3 mb-3">
			<div class="col-12 titulo">Detalle de producto</div>
		</div>
		<div class="col-12 text-left">
			<div class="col-12 bg-white">
				<b-link @click="volver()" class="bg-div-volver">&lt; Volver</b-link>
			</div>
		</div>
		<div class="col-12 pr-xl-0" ref="ancla">
			<pm-detalle-producto
				:codArticulo="codArticulo"
				:paisOrigen="paisOrigen"
				:producto="producto"
				@cantidad="cantidaObtenida"
				class="mt-4 col-12"
			></pm-detalle-producto>
		</div>
		<div class="col-12 mb-3 mt-3">
			<div class="col-12 titulo-sustitutos">Productos sustitutos</div>
		</div>
		<div class="col-12 pt-2" v-if="mostrarModalSustitutos">
			<b-alert
				show
				variant="warning"
			>No se encontraron sustitutos para el producto {{producto.descripcion}}</b-alert>
		</div>

		<div class="row col-12 pr-0 mt-4">
			<div
				:key="index"
				class="col-12 col-xl-6 d-none d-lg-block pr-0"
				v-for="(item, index) in itemsSustitutos"
			>
				<pm-card-producto
					:item="item"
					:key="index"
					:modoTarjeta="false"
					@agregarCantidad="agregarCarritoTarjeta"
					@mostrarDetalle="detalleProductoRedirect"
					class="mx-1 my-1"
				></pm-card-producto>
			</div>
		</div>

		<div class="row col-12">
			<div class="col-12 d-block d-lg-none" horizontal-order="true" transition-duration="1s" v-masonry>
				<div :key="index" v-for="(item, index) in itemsSustitutos" v-masonry-tile>
					<pm-card-producto
						:item="item"
						:key="index"
						:modoTarjeta="true"
						@agregarCantidad="agregarCarritoTarjeta"
						@mostrarDetalle="detalleProductoRedirect"
						class="mx-1 my-1"
					></pm-card-producto>
				</div>
			</div>
		</div>

		<!--Modal success-->
		<div class="justify-content-center tamano-modal">
			<b-modal class="tamano-modal" hide-footer v-model="mostrarModal">
				<div class="text-center">
					<i class="fas fa-check-circle fa-4x mb-3 animated text-success"></i>
					<p class="texto-modal">Producto agregado al carrito.</p>
				</div>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import PmDetalleProducto from "@/components/clientes/DetalleProducto.vue"
	import PmCardProducto from "@/components/clientes/CardProducto"
	import servicio from "@/services/servicio-detalle-producto"
	export default {
		data() {
			return {
				codArticulo: 0,
				producto: [],
				itemsSustitutos: [],
				paisOrigen: [],
				mostrarModal: false,
				mostrarModalSustitutos: false,
				UUIDAcceso: '',
			}
		},
		mounted() {
			this.codArticulo = this.$route.params.codArticulo
			this.detalleProducto()
		},
		components: {
			PmDetalleProducto,
			PmCardProducto,
			//TarjetaProducto
		},
		methods: {
			volver() {
				//window.history.back()
				//this.location.back()
				//let r  = localStorage.getItem('modoGrid')
				//console.log('localstoreage', r)
				
				this.$nextTick( () => {
					this.$router.go(-1)
					//
				})
				//.go(-1)	
				//next()
			},
			detalleProductoRedirect(codArticulo) {
				try {
					this.codArticulo = codArticulo
					this.detalleProducto()
					this.$router
						.push({ path: `/clientes/detalle-producto/${codArticulo}` })
						.catch((err) => err)
					this.scrollMeTo('ancla')
				} catch {
					console.log("Error")
				}
			},
			detalleProducto() {
				this.$loading(true)
				servicio
					.detalleProducto(this.codArticulo)
					.then((r) => {
						this.producto = r.data[0]

						//console.log("this.producto", this.producto)

						// console.log(
						// 	"EsOfertado =>",
						// 	this.producto.precioNeto > this.producto.precioOfertado
						// )

						if (this.producto.ofertado) {
							this.producto.ofertado =
								this.producto.precioNeto > this.producto.precioOfertado
						}

						this.paisOrigenProducto()
						this.sustitutos()
						this.$loading(false)
					})
					.catch((err) => {
						console.error(err)
						this.$loading(false)
					})
			},
			paisOrigenProducto() {
				servicio
					.productosPaisOrigen(this.codArticulo)
					.then((r) => {
						var imagen = r.data[0].imagen
						r.data[0].imagen = "data:image/png;base64," + imagen
						this.paisOrigen = r.data[0]
					})
					.catch((err) => {
						console.error(err)
					})
			},
			sustitutos() {
				this.mostrarModalSustitutos = false
				servicio
					.productosSustitutos(this.codArticulo)
					.then((r) => {
						this.itemsSustitutos = r.data
						this.$loading(false)
						if (this.itemsSustitutos.length == 0) {
							this.mostrarModalSustitutos = true
						}
					})
					.catch((error) => {
						this.$loading(false)
						console.log(error)
					})
			},
			async agregarCarritoTarjeta(item) {
				if (item.cantidad && item.cantidad > 0) {
					if(item.tipoControl == 1){
						this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
					}
					if(item.precioRemate > 0 && item.cantidad > 0){
						this.$msg.info( 'Producto de remate sin derecho a devolución.')
					}

					let token = ''
					if(window.localStorage.tokenDifarmer)
					{
						let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
						token = lstoken.token;
					}
					await this.validarClickPublicidad(item.codArticulo, token)

					this.carritoModificarCantidad(item.codArticulo, item.cantidad, this.UUIDAcceso)
				}

				// this.mostrarModal = true;
				// this.sleep(2000).then(() => {
				//     this.mostrarModal = false;
				// });
			},
			async cantidaObtenida(cantidadPedir, cantidadAnterior) {
				this.$loading(true)
				if (cantidadPedir == 0 || cantidadPedir == '') {
					cantidadPedir = 0
					
					let msgText = '¿Desea quitar del carrito el producto: ' + this.producto.descripcion + '?'

					this.$msg.question( msgText )
					.then((result) => {
						if (result.isConfirmed) {
							this.carritoModificarCantidad(this.codArticulo, cantidadPedir, this.UUIDAcceso)
							this.producto.cantidad = 0
						}
						else{
							this.producto.cantidad = cantidadAnterior
						}
					})
				}
				else{
					if(this.producto.tipoControl == 1 && cantidadPedir > 0){
						this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
					}
					if(this.producto.precioRemate > 0 && this.producto.cantidad > 0){
						this.$msg.info( 'Producto de remate sin derecho a devolución.')
					}

					let token = ''
					

					if(window.localStorage.tokenDifarmer)
					{
						let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
						token = lstoken.token;
					}

					await this.validarClickPublicidad(this.producto.codArticulo, token)
		
					this.carritoModificarCantidad(this.codArticulo, cantidadPedir,this.UUIDAcceso)


				}
				this.$loading(false)
				// this.carritoModificarCantidad(this.codArticulo, cantidadPedir)
				// 	this.mostrarModal = false
				// 	this.sleep(2000).then(() => {
				// 		this.mostrarModal = false
				// 	})
			},
			sleep(time) {
				return new Promise((resolve) => setTimeout(resolve, time))
			},
			async validarClickPublicidad(codArticulo, token){
				let r = await servicio.validarClickPublicidad({"idProducto":codArticulo, "accessToken":token} )
				if (r.data){
					this.UUIDAcceso = r.data[0]
				}
			},
		},
		watch: {
			'$route.params.codArticulo'() {
				this.codArticulo = this.$route.params.codArticulo
				this.detalleProducto()
			}
		},
	}
</script>

<style scoped>
	.titulo {
		font-size: 16px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: #0a2157;
		opacity: 1;
	}

	.titulo-sustitutos {
		font-size: 18px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: #0a2157;
		opacity: 1;
	}
	.tamano-modal {
		width: 400px;
		height: 179px;
		background-color: #ebebeb;
	}
	.bg-div-volver {
		text-align: left !important;
		font-size: 14px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: #335198;
		opacity: 1;
	}
	.texto-modal {
		text-align: center;
		font-family: "Open Sans", sans-serif;
		font-size: 16px;
		letter-spacing: 0;
		color: #273c6e;
		opacity: 1;
	}
	@media screen and (max-width: 767px) {
	}

	/* md */
	@media screen and (min-width: 768px) and (max-width: 991px) {
	}

	/* lg */
	@media screen and (min-width: 992px) {
	}
</style>

